<template>
  <div class="content-editor-block content-editor-htmlcode htmlcode">
    <!-- <textarea @input="onInput" v-html="initValue" ref="input"></textarea> -->
    <el-input v-model="mValue" @input="onInput" type="textarea" autosize placeholder="請輸入程式碼"></el-input>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: ''
    }
  },
  data: () => {
    return {
      initValue: '',
      mValue: '',
      editor: null
    }
  },
  computed: {},
  methods: {
    onInput () {
      this.$emit('input', this.mValue)
    }
  },
  created () {
    this.initValue = this.value
    this.mValue = this.value
  },
  mounted () {},
  watch: {
    value () {
      this.mValue = this.value
    }
  }
}
</script>
